import React from "react";
import ContentProductRecent from "./ContentProductRecent";

export default function ChildProductRecent() {
  return (
    <>
      <div className="section-wrapper">
        <div className="nft-sell-wrapper">
          <div className="row justify-content-center gx-4 gy-3">
            <ContentProductRecent />
          </div>
        </div>
      </div>
    </>
  );
}
